import React from 'react';
import cn from 'classnames';
import styles from './Input.scss';

const Input = ({ className, placeholder, icon, onKeyPress, onDirty,
  onChange, onFocus, onBlur, onClick, getRef, defaultValue, autofocus, onClickContainer, disabled = false,
  ...rest }) => {
  return (
    <div className={styles.Container} onClick={onClickContainer}>
      {icon ? icon : null}
      <input
        onClick={onClick}
        onKeyPress={onKeyPress}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        placeholder={placeholder}
        className={cn(styles.Input, className)}
        value={defaultValue || ''}
        ref={_input => getRef && getRef(_input)}
        autoFocus={autofocus}
        disabled={disabled}
      />
    </div>
  );
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/common/Input/Input.js